import flow from "lodash/fp/flow";
import { toObject } from "../../core/utils";
import constants from "../../core/constants";

class BackupPlanPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const format = (item) => {
      item.wage /= constants.currencyBy;

      return item;
    };
    return flow([format, toObject])(data);
  }
}

export default BackupPlanPageTransform;



// WEBPACK FOOTER //
// ./src/pages/backupPlan/backupPlan.transforms.js